<style lang="stylus">
    .vip-icon
        height 12px;
        width 12px
</style>

<template>
    <img class="vip-icon" :src="vipIcon" />
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";

    @Component
    export default class VipIcon extends Vue {
        @Prop()
        url: string;

        get vipIcon() {
            if (this.url) {
                return this.url;
            }
            if (window.EDCONFIG.IS_SDK) {
                return require("@/public/img/vip-sdk.svg");
            }
            return require("@/public/img/vip.svg");
        }
        created() {}
        mounted() {}
    }
</script>
<i18n>
    {
        "zh": {},
        "en": {},
        "fr": {},
        "de": {},
        "jp": {},
        "es": {},
        "pt": {},
        "it": {},
        "tw": {},
        "kr": {}
    }
</i18n>
